/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import dagre from 'dagre'
import { Edge, Node } from 'reactflow'
import { IDepartment } from '../../../../../../interfaces'

export function buildReactFlowGraph(
  departments: IDepartment[],
  cores: string[],
  savedNodes?: Node[]
): { nodes: Node[], edges: Edge[] } {
  const nodes: Node[] = []
  const edges: Edge[] = []
  let cumulativeYOffset = 0

  function getMaxDepth(dept: IDepartment, depth = 1): number {
    if (!dept.departamentoFilhos || dept.departamentoFilhos.length === 0) {
      return depth
    }
    return Math.max(
      ...dept.departamentoFilhos.map((child) => getMaxDepth(child, depth + 1))
    )
  }

  departments.forEach((dept) => {
    const thisTreeDepth = getMaxDepth(dept)
    const yOffset = cumulativeYOffset
    const nodeLevels: Record<string, number> = {}

    const gSub = new dagre.graphlib.Graph()
    gSub.setGraph({ rankdir: 'TB', nodesep: 50, ranksep: 130 })
    gSub.setDefaultEdgeLabel(() => ({}))

    function traverse(deptLocal: IDepartment, parentId?: string, depth = 0): void {
      const nodeId = deptLocal.id
      const hasSub = deptLocal.colaboradores?.some(e => e.subordinados)

      gSub.setNode(nodeId, {
        width: 930,
        height: hasSub ? 390 : 245
      })

      if (parentId) {
        gSub.setEdge(parentId, nodeId)
      }

      nodeLevels[nodeId] = depth

      deptLocal.departamentoFilhos?.forEach(child => {
        traverse(child, nodeId, depth + 1)
      })
    }

    traverse(dept)

    dagre.layout(gSub)

    const xs = gSub.nodes().map((id) => gSub.node(id).x)
    const minX = Math.min(...xs)
    const maxX = Math.max(...xs)
    const width = maxX - minX
    const targetWidth = 1500
    const centerOffsetX = (targetWidth - width) / 2 - minX

    gSub.nodes().forEach((nodeId: any) => {
      const n = gSub.node(nodeId)
      const deptData = findDepartmentById([dept], nodeId)
      if (!deptData) return

      const hasSub = deptData.colaboradores?.some(e => e.subordinados)

      // Verifica se existe salvo
      const saved = savedNodes?.find(sn => sn.data?.departamentoId === deptData.id)

      nodes.push({
        id: nodeId,
        type: 'custom',
        data: {
          departamentoId: deptData.id,
          label: deptData.nome,
          colaboradores: deptData.colaboradores || [],
          larguraCalculada: saved?.width ?? 930,
          alturaCalculada: saved?.height ?? (hasSub ? 390 : 245),
          cor: deptData.cor,
          cores: cores,
          nivel: nodeLevels[nodeId]
        },
        position: saved?.position || {
          x: n.x + centerOffsetX,
          y: n.y + yOffset
        },
        width: saved?.width ?? 930,
        height: saved?.height ?? (hasSub ? 390 : 245)
      })
    })

    gSub.edges().forEach((edgeObj: any) => {
      edges.push({
        id: `e${edgeObj.v}-${edgeObj.w}`,
        source: edgeObj.v,
        target: edgeObj.w
      })
    })

    cumulativeYOffset += thisTreeDepth * 400
  })

  return { nodes, edges }
}

function findDepartmentById(
  depts: IDepartment[],
  id: string
): IDepartment | undefined {
  for (const d of depts) {
    if (d.id === id) return d
    if (d.departamentoFilhos) {
      const found = findDepartmentById(d.departamentoFilhos, id)
      if (found) return found
    }
  }
  return undefined
}
